import React, { useEffect, useState } from "react";
import { 
  Col, Container, Row, Card, CardBody, Badge, 
  Spinner, Button, Modal, ModalHeader, ModalBody, 
  Label, Input, Form, Nav, NavItem, NavLink, TabContent, TabPane 
} from "reactstrap";
import classnames from "classnames";
import Breadcrumbs from "components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";

const KullaniciGrid = () => {
  document.title = "Kullanıcı Grid | HarmanaGEL Admin";

  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // Modal State'leri
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [isSaving, setIsSaving] = useState(false);
  const [isDetailsLoading, setIsDetailsLoading] = useState(false);

  // Seçili Kullanıcı Verileri
  const [selectedUser, setSelectedUser] = useState(null);
  const [detailedUser, setDetailedUser] = useState(null);

  // Rol Kontrolü: Admin ID 3
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.HESAP_TURU === 'Admin';

  useEffect(() => {
    if (isAdmin) fetchUsers();
  }, [isAdmin]);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await fetch("https://harmanagelapi.stechomeyazilim.info/KULLANICILAR?$expand=HESAP_TURU&$orderby=ID desc");
      const result = await response.json();
      setUsers(result.value || []);
    } catch (error) {
      toast.error("Veriler yüklenemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  // --- PROFİL GÖRÜNTÜLEME (OData Expand) ---
  const handleViewProfile = async (user) => {
    setSelectedUser(user);
    setViewModal(true);
    setIsDetailsLoading(true);
    setActiveTab("1");
    try {
      const response = await fetch(
        `https://harmanagelapi.stechomeyazilim.info/KULLANICILAR?$filter=ID eq ${user.ID}&$expand=Users_Address,Users_Driving_License,Users_BankAccount,Users_Document,Users_Company($expand=Users_Invoince)`
      );
      const result = await response.json();
      if (result.value && result.value.length > 0) {
        setDetailedUser(result.value[0]);
      }
    } catch (error) {
      toast.error("Detaylar yüklenemedi.");
    } finally {
      setIsDetailsLoading(false);
    }
  };

  // --- DÜZENLEME KAYDETME (PUT) ---
  const handleUpdateUser = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/KULLANICILAR(${selectedUser.ID})`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          AD_SOYAD: selectedUser.AD_SOYAD,
          Mail_Adress: selectedUser.Mail_Adress,
          CEP_NONumber: selectedUser.CEP_NONumber,
          HESAP_TURU: selectedUser.HESAP_TURU,
          AKTIF_DURUM: selectedUser.AKTIF_DURUM
        })
      });
      if (response.ok) {
        toast.success("Güncellendi.");
        setEditModal(false);
        fetchUsers();
      }
    } catch (error) {
      toast.error("Hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcı Grid" />
          
          {isLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : (
            <Row>
              {users.map((user, key) => (
                <Col xl="3" md="6" key={key}>
                  <Card className="text-center shadow-sm border-0 mb-4 h-100">
                    <CardBody>
                      <div className="avatar-sm mx-auto mb-4">
                        <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-16">
                          {user.AD_SOYAD?.charAt(0)}
                        </span>
                      </div>
                      <h5 className="font-size-15 mb-1">{user.AD_SOYAD}</h5>
                      <p className="text-muted mb-2">{user.Users_Type?.Users_Type_Title || "Sürücü"}</p>
                      <Badge color={user.AKTIF_DURUM ? "success" : "danger"} pill className="mb-3 px-3">
                        {user.AKTIF_DURUM ? "Aktif" : "Pasif"}
                      </Badge>
                      <div className="text-muted font-size-13">
                         <i className="bx bx-envelope me-1"></i> {user.Mail_Adress}
                      </div>
                    </CardBody>
                    <div className="btn-group" role="group">
                      <Button color="light" className="btn-sm border-end w-50" onClick={() => handleViewProfile(user)}>
                        <i className="mdi mdi-eye outline me-1"></i> Profil
                      </Button>
                      <Button color="light" className="btn-sm w-50 text-success" onClick={() => { setSelectedUser(user); setEditModal(true); }}>
                        <i className="mdi mdi-pencil outline me-1"></i> Düzenle
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Container>

        {/* --- MODAL 1: PROFİL GÖR --- */}
        <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="xl" centered>
          <ModalHeader toggle={() => setViewModal(false)}>Kullanıcı Profili Detayı</ModalHeader>
          <ModalBody className="bg-light-subtle">
            {isDetailsLoading ? <div className="text-center py-5"><Spinner color="primary" /></div> : detailedUser && (
              <>
                <Nav tabs className="nav-tabs-custom nav-justified mb-3 bg-white">
                  <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => setActiveTab("1")} style={{cursor:'pointer'}}>Genel</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeTab === "2" })} onClick={() => setActiveTab("2")} style={{cursor:'pointer'}}>Ehliyet</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeTab === "3" })} onClick={() => setActiveTab("3")} style={{cursor:'pointer'}}>Şirket</NavLink></NavItem>
                  <NavItem><NavLink className={classnames({ active: activeTab === "4" })} onClick={() => setActiveTab("4")} style={{cursor:'pointer'}}>Belgeler</NavLink></NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Card><CardBody><Row>
                        <Col md={6}><Label className="text-muted mb-0">Ad Soyad</Label><p className="fw-bold">{detailedUser.AD_SOYAD}</p></Col>
                        <Col md={6}><Label className="text-muted mb-0">E-posta</Label><p className="fw-bold">{detailedUser.Mail_Adress}</p></Col>
                        <Col md={12}><Label className="text-muted mb-0">Adres</Label><p>{detailedUser.Users_Address?.[0]?.Users_Address_AdressText || "Yok"}</p></Col>
                    </Row></CardBody></Card>
                  </TabPane>
                  <TabPane tabId="4">
                    <Row>
                        {["Kimlik", "Ehliyet", "Vergi"].map((n, i) => (
                            <Col md={4} key={i}><Card className="text-center p-3 border shadow-none"><i className="mdi mdi-file-pdf display-4 text-danger"></i><p className="mt-2">{n}</p></Card></Col>
                        ))}
                    </Row>
                  </TabPane>
                </TabContent>
              </>
            )}
          </ModalBody>
        </Modal>

        {/* --- MODAL 2: DÜZENLE --- */}
        <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
          <ModalHeader toggle={() => setEditModal(false)}>Kullanıcıyı Düzenle</ModalHeader>
          <ModalBody>
            {selectedUser && (
              <Form onSubmit={handleUpdateUser}>
                <div className="mb-3"><Label>Ad Soyad</Label><Input value={selectedUser.AD_SOYAD} onChange={e => setSelectedUser({...selectedUser, AD_SOYAD: e.target.value})} /></div>
                <div className="mb-3"><Label>E-posta</Label><Input value={selectedUser.Mail_Adress} onChange={e => setSelectedUser({...selectedUser, Mail_Adress: e.target.value})} /></div>
                <div className="mb-3">
                  <Label>Durum</Label>
                  <Input type="select" value={selectedUser.AKTIF_DURUM} onChange={e => setSelectedUser({...selectedUser, AKTIF_DURUM: e.target.value === "true"})}>
                    <option value="true">Aktif</option>
                    <option value="false">Pasif</option>
                  </Input>
                </div>
                <div className="text-end mt-4">
                  <Button color="primary" type="submit" disabled={isSaving}>{isSaving ? <Spinner size="sm" /> : "Kaydet"}</Button>
                </div>
              </Form>
            )}
          </ModalBody>
        </Modal>
      </div>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default KullaniciGrid;